<template>
  <v-tooltip location="top">
    <template v-slot:activator="{ props }">
      <!-- The image that triggers the tooltip -->
      <v-img :src="icon" contain height="40" width="40" v-bind="props"></v-img>
    </template>

    <!-- Tooltip content: display the pack name -->
    <span>{{ pack }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "PackTooltip",
  props: {
    icon: {
      type: String,
      required: true,
    },
    pack: {
      type: String,
      required: true,
    },
  },
};
</script>
